"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AircrewTypeSortKeysType = void 0;
var AircrewTypeSortKeysType;
(function (AircrewTypeSortKeysType) {
    // These are camel case because they are object properties and should be equals to a database fields
    AircrewTypeSortKeysType["Type"] = "type";
})(AircrewTypeSortKeysType = exports.AircrewTypeSortKeysType || (exports.AircrewTypeSortKeysType = {}));
